import React from 'react';
import { ExpandGroupProvider } from './expand-group-context';

const ExpandGroup = props => {
  const {
    expandMultiple,
    children
  } = props;
  return /*#__PURE__*/React.createElement(ExpandGroupProvider, {
    expandMultiple: expandMultiple
  }, children);
};

export default ExpandGroup;